import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Forum Themes',
  basePath: '/forum-themes',
  columns: [
    { key: 'last_modyfication', label: 'Last Modified', sortable: true },
    { key: 'forumtemat_name', label: 'Theme', sortable: true },
    { key: 'forumtemat_date', label: 'Date', sortable: true },
    { key: 'companytype_name', label: 'Sector', sortable: true },
  ],
  fields: [
    { key: 'forumtemat_name', label: 'Forum theme', type: 'text', required: true },
    { key: 'companytype_id', label: 'Sector', type: 'async-select',
      optionsUrl: '/company-types/options',
      iconProp: 'icon',
      placeholder: 'Select article type' },
  ],
  filters: [
    { key: 'companyType', label: 'Sector', type: 'select',
      optionsUrl: '/company-types/options' },
    { key: 'dateFrom', label: 'Date From', type: 'date' },
    { key: 'dateTo', label: 'Date To', type: 'date' },
  ],
  defaultSort: { field: 'last_modyfication', dir: 'desc' },
});
